import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCurrentModDetails,
  selectIsEditMod,
  selectIsUndoModal,
} from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { dataSorting, findKeyBaseOnValue, travelerRequestedHousingTypeOption } from '../../ModificationsUtils';
import { getFilteredOptions, updateStandardAmount } from './HousingUtility';

export const TravelerRequestedHousingType = () => {
  const { control, getValues, setValue, setError, clearErrors, register, watch } = useFormContext();
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const isModEdit = useSelector(selectIsEditMod);
  const isUndoModal = useSelector(selectIsUndoModal);
  const dispatch = useDispatch();
  const currentModDetails = useSelector(selectCurrentModDetails);
  register('travelerRequestedHousingTypeId');
  const { t } = useTranslation();
  const travelerRequestedHousingType = 'travelerRequestedHousingType';
  const trhtValue = watch(travelerRequestedHousingType);
  const getId = (value: string) => {
    const selectedOption = findKeyBaseOnValue(travelerRequestedHousingTypeOption, value);
    return selectedOption.Id;
  };
  const onSelectionChange = (value?: string) => {
    setValue(travelerRequestedHousingType, value);
    setValue('travelerRequestedHousingTypeId', getId(value));
    setValue('actualHousingType', value);
    setValue('actualHousingTypeId', getId(value));
    updateStandardAmount(currentModDetails, setValue, getId(value));
    if (value) {
      clearErrors(travelerRequestedHousingType);
      clearErrors('actualHousingType');
    }
  };

  useEffect(() => {
    if (trhtValue) {
      setValue('travelerRequestedHousingTypeId', getId(trhtValue));
      clearErrors(travelerRequestedHousingType);
    } else {
      setError(travelerRequestedHousingType, {});
    }
    if (isUndoModal) {
      dispatch(placementModsAction.setIsUndoModal(false));
    }
  }, [clearErrors, dispatch, isUndoModal, setError, setValue, trhtValue]);

  return (
    <Controller
      control={control}
      name={travelerRequestedHousingType}
      rules={{
        required: true,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <FormInputDropdown
          useMenuItem={true}
          name={travelerRequestedHousingType}
          label={t('placement.placementMods.travelerRequestedHousingType')}
          standard={true}
          options={dataSorting(getFilteredOptions(currentModDetails, getValues('housingProviderId'))) ?? []}
          handleChange={e => {
            onSelectionChange(e.target.value);
            onChange(e.target.value);
          }}
          inputValue={getValues(travelerRequestedHousingType) ?? ''}
          readOnly={!isModEdit}
          disabled={isSaveModApiCalling || !getValues('housingProviderId')}
          {...rest}
        ></FormInputDropdown>
      )}
    />
  );
};
